import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';

type Props = {
  text: string | number;
  badgeTextClasses?: Argument;
};
export const BadgeText: React.FC<Props> = ({ text, badgeTextClasses }) => (
  <span className={cs('bbk-badge-text', badgeTextClasses)}>{text}</span>
);
